;(function () {
  'use strict'

  angular
    .module('contrast.services.send.bugtrackers')
    .factory('SendBugtrackerService', SendBugtrackerService)

  function SendBugtrackerService(
    $q,
    ErrorService,
    JiraBugtrackerService,
    VSTSService,
    GitHubService,
    AgileCentralBugtrackerService,
    INTEGRATION_TYPE,
    VSTS_PRIORITIES,
    VSTS_UNASSIGNED,
    $translate
  ) {
    'ngInject'

    var MIN_SEARCH_STRING_LENGTH = 2
    var MAX_ASSIGNEES_IN_DROPDOWN = 100

    return {
      onChangeValueField: onChangeValueField,
      openDatepicker: openDatepicker,

      isJira: isJira,
      isVSTS: isVSTS,
      isGitHub: isGitHub,
      isAgileCentral: isAgileCentral,
      isPriorityFieldAvailable: isPriorityFieldAvailable,

      selectBugtracker: selectBugtracker,
      onChangeIssueType: onChangeIssueType,
      onChangeField: onChangeField,
      validForm: validForm,
      showText: showText,
      getUsersFromBugtracker: getUsersFromBugtracker,

      createRequest: createRequest,
      ok: ok,
      cancel: cancel,
      filterAssignees
    }

    function filterAssignees(assignees, searchString, isJira) {
      if (!searchString || searchString.length < MIN_SEARCH_STRING_LENGTH) {
        return []
      }
      var nameField = isJira ? 'displayName' : 'display_name'
      var searchRegex = new RegExp(searchString, 'gi')
      var matches = []
      for (var i = 0; i < assignees.length; i++) {
        if (assignees[i][nameField].match(searchRegex)) {
          matches.push(assignees[i])
          if (matches.length === MAX_ASSIGNEES_IN_DROPDOWN) {
            break
          }
        }
      }
      return matches
    }

    function onChangeValueField(vm, additionalField) {
      if (!vm.selected_fields) {
        vm.selected_fields = []
      }

      var selectedField = _.find(vm.selected_fields, {
        key: additionalField.field.key
      })
      if (!selectedField) {
        selectedField = additionalField.field
        vm.selected_fields.push(selectedField)
      }

      selectedField.value = additionalField.value
      selectedField.values = additionalField.values
    }

    function openDatepicker($event, additionalField) {
      $event.preventDefault()
      $event.stopPropagation()
      return (additionalField.openedDatepicker = true)
    }

    function isJira(vm) {
      return (
        angular.isDefined(vm) &&
        angular.isDefined(vm.select.selectedBugtracker) &&
        vm.select.selectedBugtracker.keycode === INTEGRATION_TYPE.JIRA
      )
    }

    function isVSTS(vm) {
      return (
        angular.isDefined(vm) &&
        angular.isDefined(vm.select.selectedBugtracker) &&
        vm.select.selectedBugtracker.keycode === INTEGRATION_TYPE.VSTS
      )
    }

    function isGitHub(vm) {
      return (
        angular.isDefined(vm) &&
        angular.isDefined(vm.select.selectedBugtracker) &&
        vm.select.selectedBugtracker.keycode === INTEGRATION_TYPE.GITHUB
      )
    }

    function isAgileCentral(vm) {
      return (
        angular.isDefined(vm) &&
        angular.isDefined(vm.select.selectedBugtracker) &&
        vm.select.selectedBugtracker.keycode === INTEGRATION_TYPE.AGILE_CENTRAL
      )
    }

    function isPriorityFieldAvailable(vm) {
      return (
        isJira(vm) &&
        vm.properties.issue_type &&
        vm.properties.issue_type.priority_field_available
      )
    }

    function selectBugtracker(bugtracker, appId, traces, vm, type) {
      if (
        bugtracker.keycode === INTEGRATION_TYPE.JIRA &&
        bugtracker.full_integration
      ) {
        _getJiraIntegration(bugtracker, traces, type, vm, appId)
      } else if (bugtracker.keycode === INTEGRATION_TYPE.VSTS) {
        _getVSTSIntegration(bugtracker, traces, type, vm, appId)
      } else if (bugtracker.keycode === INTEGRATION_TYPE.GITHUB) {
        _getGitHubIntegration(bugtracker, traces, type, vm, appId)
      } else if (bugtracker.keycode === INTEGRATION_TYPE.AGILE_CENTRAL) {
        _getAgileCentralIntegration(bugtracker, traces, type, vm, appId)
      } else {
        vm.validConnnection = true
      }
    }

    function onChangeIssueType(vm, issueType) {
      if (isJira(vm)) {
        JiraBugtrackerService.fillAdditionalJIRAFields(vm, issueType)
      } else if (isVSTS(vm)) {
        if (angular.isUndefined(issueType)) {
          return
        }

        vm.properties.issue_type = issueType

        vm.properties.priority = undefined

        if (issueType.default_field) {
          vm.select.priorities = issueType.default_field.values

          if (
            angular.isDefined(vm.properties) &&
            angular.isDefined(vm.properties.defaultPriority)
          ) {
            if (
              vm.select.priorities.indexOf(vm.properties.defaultPriority) > -1
            ) {
              vm.properties.priority = vm.properties.defaultPriority
            }
          }
        } else {
          vm.select.priorities = []
        }

        _fillPrioritiesFields(vm)
      }
    }

    function onChangeField(vm, field, additionalField) {
      additionalField.value = ''
      additionalField.values = []
      additionalField.field = field
      additionalField.openedDatepicker = false

      additionalField.template = ''
      //potentially change this
      additionalField.template = JiraBugtrackerService.includeTemplate(field)

      JiraBugtrackerService.consolidateSelectFields(vm)
    }

    function validForm(vm) {
      var invalidForm =
        vm.form.assignee.$invalid ||
        vm.form.issue_type.$invalid ||
        vm.form.priority.$invalid

      var invalidRequiredFields = false
      _.each(vm.select.required_fields, function (requiredField) {
        if (
          !invalidRequiredFields &&
          !requiredField.value &&
          (!requiredField.values || requiredField.values.length === 0)
        ) {
          invalidRequiredFields = true
        }
      })

      return invalidForm || invalidRequiredFields
    }

    function showText(bugtracker) {
      return bugtracker.name + ' (' + bugtracker.keycode + ')'
    }

    function getUsersFromBugtracker(keyword, vm, listToUpdate) {
      _getUsersFromBugtracker(
        keyword,
        vm.select.selectedBugtracker,
        vm.properties,
        vm.credentials_id
      )
        .then(function (response) {
          if (response.data && response.data.data) {
            vm.select[listToUpdate] = response.data.data
          } else {
            vm.select[listToUpdate] = undefined
          }
        })
        .catch(ErrorService.processError)
    }

    function _getUsersFromBugtracker(
      keyword,
      selectedBugtracker,
      properties,
      credentialsId
    ) {
      if (selectedBugtracker.keycode === INTEGRATION_TYPE.AGILE_CENTRAL) {
        if (!angular.isDefined(properties.project)) {
          return $q.when({ response: undefined })
        }
        var request = { name: 'Users request', credentials_id: credentialsId }
        var projectId = AgileCentralBugtrackerService.getObjectIdFromReference(
          properties.project
        )
        return AgileCentralBugtrackerService.getEditors(
          request,
          projectId,
          keyword,
          selectedBugtracker.bugtracker_id
        )
      } else {
        var errorResponse = {
          data: {
            messages: [
              $translate.instant(
                'detail_sendVulnerability_unsupportedBugtrackerForUsersSearch'
              )
            ]
          }
        }
        $q.reject(errorResponse)
      }
    }

    function _loadJiraBugtracker(type, bugtrackerId, appId) {
      if (type === 'trace') {
        return JiraBugtrackerService.getJiraBugtrackerForVulnerability(
          bugtrackerId,
          appId
        )
      } else {
        return JiraBugtrackerService.getJiraBugtrackerForLibrary(bugtrackerId)
      }
    }

    function _loadJiraBugtrackerPriority(
      type,
      bugtrackerId,
      entityList,
      appId,
      vm
    ) {
      if (type === 'trace') {
        return JiraBugtrackerService.getJiraPriorityByTraces(
          bugtrackerId,
          entityList,
          appId
        )
      } else {
        return $q.when({ data: { priority: vm.select.priorities[0].name } })
      }
    }

    function _getJiraIntegration(bugtracker, entityList, type, vm, appId) {
      vm.testing = true
      vm.bugtrackerPromise = _loadJiraBugtracker(
        type,
        bugtracker.bugtracker_id,
        appId
      )
        .then(function (response) {
          JiraBugtrackerService.buildJiraBugtrackerSettings(vm, response.data)
        })
        .then(function () {
          return _loadJiraBugtrackerPriority(
            type,
            bugtracker.bugtracker_id,
            entityList,
            appId,
            vm
          )
        })
        .then(function (response) {
          vm.properties.priority = _.find(vm.select.priorities, {
            name: response.data.priority
          })
          vm.validConnnection = true
        })
        .catch(function (response) {
          vm.validConnnection = false
          ErrorService.processError(response)
        })
        .finally(function () {
          vm.testing = false
        })
    }

    function _loadVSTSBugtracker(type, bugtrackerId, appId) {
      if (type === 'trace') {
        return VSTSService.getVSTSBugtrackerForVulnerability(
          bugtrackerId,
          appId
        )
      } else {
        return VSTSService.getVSTSBugtrackerForLibrary(bugtrackerId)
      }
    }

    function _loadVSTSBugtrackerPriority(
      type,
      bugtrackerId,
      entityList,
      appId,
      vm
    ) {
      if (type === 'trace') {
        return VSTSService.getVSTSPriorityByTraces(
          bugtrackerId,
          entityList,
          appId
        )
      } else {
        return $q.when(vm.select.priorities[0])
      }
    }

    function _getVSTSIntegration(bugtracker, entityList, type, vm, appId) {
      vm.testing = true
      vm.bugtrackerPromise = _loadVSTSBugtracker(
        type,
        bugtracker.bugtracker_id,
        appId
      )
        .then(function (bugtrackerInfo) {
          vm.properties = bugtrackerInfo

          var request = VSTSService.buildVSTSIntegrationProjects(
            bugtrackerInfo,
            null,
            bugtrackerInfo.project
          )

          vm.settingsPromise =
            VSTSService.getExisitingVSTSBugtrackerProjectSettings(
              bugtracker.bugtracker_id,
              request
            )

          return vm.settingsPromise
        })
        .then(function (settings) {
          vm.select.workItemTypes = settings.work_item_types
          _fillDefaultValues(vm)

          var request = VSTSService.buildVSTSIntegrationProjectTeams(
            vm.properties,
            null,
            vm.properties.project,
            vm.properties.team
          )

          return VSTSService.getVSTSBugtrackerTeamMembers(
            request,
            vm.properties.bugtracker_id
          )
        })
        .then(function (members) {
          vm.select.assignees = members
          _fillAssignees(vm, vm.select.assignees)
        })
        .then(function () {
          return _loadVSTSBugtrackerPriority(
            type,
            bugtracker.bugtracker_id,
            entityList,
            appId,
            vm
          )
        })
        .then(function (priority) {
          vm.properties.defaultPriority = priority
          if (vm.select.priorities.indexOf(priority) > -1) {
            vm.properties.priority = priority
          }
          vm.validConnnection = true
        })
        .catch(function (response) {
          vm.validConnnection = false
          ErrorService.processError(response)
        })
        .finally(function () {
          vm.testing = false
        })
    }

    function _loadGitHubBugtracker(type, bugtrackerId, appId) {
      if (type === 'trace') {
        return GitHubService.getGitHubBugtrackerForVulnerability(
          bugtrackerId,
          appId
        )
      } else {
        return GitHubService.getGitHubBugtrackerForLibrary(bugtrackerId)
      }
    }

    function _getGitHubIntegration(bugtracker, entityList, type, vm, appId) {
      vm.testing = true
      vm.bugtrackerPromise = _loadGitHubBugtracker(
        type,
        bugtracker.bugtracker_id,
        appId
      )
        .then(function (bugtrackerInfo) {
          vm.properties = bugtrackerInfo.bugtracker
          vm.select.labels = bugtrackerInfo.settings.labels
          vm.select.assignees = bugtrackerInfo.settings.assignees
          vm.select.milestones = bugtrackerInfo.settings.milestones
          _fillRepositorySettings(vm)

          vm.validConnnection = true
        })
        .catch(function (response) {
          vm.validConnnection = false
          ErrorService.processError(response)
        })
        .finally(function () {
          vm.testing = false
        })
    }

    function _loadAgileCentralBugtracker(type, bugtrackerId, appId) {
      if (type === 'trace') {
        return AgileCentralBugtrackerService.getBugtrackerForVulnerability(
          bugtrackerId,
          appId
        )
      } else {
        return AgileCentralBugtrackerService.getBugtrackerForLibrary(
          bugtrackerId
        )
      }
    }

    function _getAgileCentralIntegration(
      bugtracker,
      entityList,
      type,
      vm,
      appId
    ) {
      vm.testing = true
      vm.bugtrackerPromise = _loadAgileCentralBugtracker(
        type,
        bugtracker.bugtracker_id,
        appId
      )
        .then(function (response) {
          var bugtrackerInfo = response.data

          vm.select.priorities =
            AgileCentralBugtrackerService.removeEmptyValueFromArray(
              bugtrackerInfo.settings.priorities
            )
          vm.select.states =
            AgileCentralBugtrackerService.removeEmptyValueFromArray(
              bugtrackerInfo.settings.states
            )
          vm.select.environments =
            AgileCentralBugtrackerService.removeEmptyValueFromArray(
              bugtrackerInfo.settings.environments
            )

          vm.properties =
            AgileCentralBugtrackerService.setupAgileCentralBugtrackerBaseProperties(
              bugtrackerInfo.bugtracker,
              vm.select
            )
          vm.properties =
            AgileCentralBugtrackerService.buildAgileCentralBugtrackerBaseProperties(
              vm.properties,
              vm.select
            )
          vm.credentials_id = bugtrackerInfo.bugtracker.credentials_id
          vm.properties.project = bugtrackerInfo.bugtracker.project
        })
        .then(function () {
          var request = {
            name: 'User request',
            credentials_id: vm.credentials_id
          }
          var ownerPromise
          var submitterPromise

          if (angular.isDefined(vm.properties.owner)) {
            ownerPromise = AgileCentralBugtrackerService.getUser(
              request,
              vm.properties.owner.ref,
              bugtracker.bugtracker_id
            ).then(function (response) {
              if (response.data.data) {
                vm.properties.owner = response.data.data
              } else {
                vm.properties.owner = undefined
              }
            })
          } else {
            ownerPromise = $q.when({}, function () {
              vm.properties.owner = undefined
            })
          }
          if (angular.isDefined(vm.properties.submittedBy)) {
            submitterPromise = AgileCentralBugtrackerService.getUser(
              request,
              vm.properties.submittedBy.ref,
              bugtracker.bugtracker_id
            ).then(function (response) {
              if (response.data.data) {
                vm.properties.submittedBy = response.data.data
              } else {
                vm.properties.submittedBy = undefined
              }
            })
          } else {
            submitterPromise = $q.when({}, function () {
              vm.properties.submittedBy = undefined
            })
          }

          return $q.all([ownerPromise, submitterPromise])
        })
        .then(function () {
          return _loadAgileCentralPriorityByTraces(
            bugtracker.bugtracker_id,
            entityList,
            appId,
            vm,
            type
          )
        })
        .then(function (response) {
          vm.properties.priority = _.find(vm.select.priorities, {
            stringValue: response.data.priority
          })
          vm.validConnnection = true
        })
        .catch(function (response) {
          vm.validConnnection = false
          ErrorService.processError(response)
        })
        .finally(function () {
          vm.testing = false
        })
    }

    function _loadAgileCentralPriorityByTraces(id, traces, appId, vm, type) {
      if (type === 'trace') {
        return AgileCentralBugtrackerService.getPriorityByTraces(
          id,
          traces,
          appId
        )
      } else if (vm.select.priorities.length > 0) {
        return $q.when({ data: { priority: vm.select.priorities[0] } })
      } else {
        return $q.when({ data: { priority: undefined } })
      }
    }

    function _fillRepositorySettings(vm) {
      if (angular.isDefined(vm.properties.labels)) {
        var selectedLabels = _.filter(vm.select.labels, function (label) {
          return _.includes(vm.properties.labels, label.name)
        })

        if (vm.properties.labels && selectedLabels.length > 0) {
          vm.properties.labels = selectedLabels
        }
      }

      if (angular.isDefined(vm.properties.milestone)) {
        vm.properties.milestone = _.find(vm.select.milestones, {
          number: vm.properties.milestone
        })
      }

      if (angular.isDefined(vm.properties.assignees)) {
        var selectedAssignees = _.filter(
          vm.select.assignees,
          function (assignee) {
            return _.includes(vm.properties.assignees, assignee.login)
          }
        )

        if (vm.properties.assignees && selectedAssignees.length > 0) {
          vm.properties.assignees = selectedAssignees
        }
      }
    }

    function _fillDefaultValues(vm) {
      _fillWorkItemTypes(vm, vm.select.workItemTypes)
    }

    function _fillWorkItemTypes(vm, issueTypes) {
      if (issueTypes && issueTypes.length > 0) {
        vm.select.workItemTypes = issueTypes

        if (!vm.properties.issue_type) {
          onChangeIssueType(vm, vm.select.workItemTypes[0])
        } else {
          var issue = _.filter(vm.select.workItemTypes, function (item) {
            return item.type.name === vm.properties.issue_type
          })[0]

          onChangeIssueType(vm, issue)
        }
      }
    }

    function _fillAssignees(vm, assignees) {
      vm.select.assignees.unshift(VSTS_UNASSIGNED)

      if (assignees && assignees.length > 0) {
        vm.select.assignees = assignees

        if (!vm.properties.assignee) {
          vm.properties.assignee = vm.select.assignees[0]
        } else {
          vm.properties.assignee = _.find(vm.select.assignees, {
            unique_name: vm.properties.assignee
          })
        }
      } else {
        vm.select.assignees = []
      }
    }

    function _fillPrioritiesFields(vm) {
      var issue = vm.properties.issue_type

      if (vm.select.priorities.length > 0 && issue.default_field) {
        if (!vm.properties.priority_critical) {
          vm.properties.priority_critical =
            issue.default_field.default_severity_values[
              VSTS_PRIORITIES.CRITICAL
            ]
        }
        if (!vm.properties.priority_high) {
          vm.properties.priority_high =
            issue.default_field.default_severity_values[VSTS_PRIORITIES.HIGH]
        }
        if (!vm.properties.priority_medium) {
          vm.properties.priority_medium =
            issue.default_field.default_severity_values[VSTS_PRIORITIES.MEDIUM]
        }
        if (!vm.properties.priority_low) {
          vm.properties.priority_low =
            issue.default_field.default_severity_values[VSTS_PRIORITIES.LOW]
        }
        if (!vm.properties.priority_note) {
          vm.properties.priority_note =
            issue.default_field.default_severity_values[VSTS_PRIORITIES.NOTE]
        }
      } else {
        vm.properties.priority_critical = ''
        vm.properties.priority_high = ''
        vm.properties.priority_medium = ''
        vm.properties.priority_low = ''
        vm.properties.priority_note = ''
      }
    }

    function createRequest(vm) {
      var bugtracker = vm.select.selectedBugtracker

      vm.sending = true
      vm.errorCode = undefined
      vm.errorMsgs = []

      if (
        bugtracker.keycode === INTEGRATION_TYPE.JIRA &&
        bugtracker.full_integration
      ) {
        JiraBugtrackerService.addJiraIntegration(vm.model, vm.properties)
        JiraBugtrackerService.buildJiraFields(
          vm.model,
          vm.select.required_fields,
          false
        )
      } else if (bugtracker.keycode === INTEGRATION_TYPE.VSTS) {
        VSTSService.addVSTSIntegration(vm.model, vm.properties)
      } else if (bugtracker.keycode === INTEGRATION_TYPE.GITHUB) {
        GitHubService.addGitHubIntegration(vm.model, vm.properties)
      } else if (bugtracker.keycode === INTEGRATION_TYPE.AGILE_CENTRAL) {
        AgileCentralBugtrackerService.addAgileCentralIntegration(
          vm.model,
          vm.properties
        )
      }
    }

    function ok(vm, promise, instance) {
      promise
        .then(function () {
          if (angular.isUndefined(vm.errorCode) && vm.errorMsgs.length === 0) {
            instance.close()
          }
        })
        .catch(function (response) {
          vm.errorCode = response.errorCode
          vm.errorMsgs = vm.errorMsgs.concat(response.errorMsgs)
        })
        .finally(function () {
          vm.sending = false
        })
    }

    function cancel(instance) {
      instance.dismiss('cancel')
    }
  }
})()
